<template>
<div>

    <b-row style="margin-top:10px; margin-bottom:10px" class="justify-content-center">
        <b-col class="col-md-8 col-10" style="padding:0.2rem; text-align:center">
        <b-button-group style="padding:0.2rem; text-align:center">
        <b-button size="sm" :variant="(roomShow === 'all') ? 'greenw':'darkblue'" @click="selectRooms('all'); roomShow='all'">All Rooms </b-button>
        <b-button size="sm" :variant="(roomShow === 'team') ? 'greenw':'darkblue'" @click="selectRooms('team'); roomShow='team'">Teams Rooms</b-button>
        <b-button size="sm" :variant="(roomShow === 'private') ? 'greenw':'darkblue'" @click="selectRooms('custom'); roomShow='private'">Private Rooms</b-button>
        </b-button-group>
        </b-col>

        <b-button variant="emptyB" 
          @click="OpenChatSupport()"
          title="Contact QUANTEEC team directly by Chat" 
          >
            <b-img fluid :src="require(`@/assets/logo.svg`)" style="height:15px"></b-img>
            <font-awesome-icon :icon="['far', 'comment']" transform="shrink-3 up-3 left-3"></font-awesome-icon>
        </b-button>

    </b-row>
  <chat-window
    v-if="socketChat!=null"
    :current-user-id="currentUserId"
    :rooms="rooms"
    :messages="messages"
    :messages-loaded="messagesLoaded"
    :rooms-loaded="roomsLoaded"
    :loading-rooms="loadingRooms"
    :show-new-messages-divider="false"
    
    @add-room="createPrivateConversationModal"	
    @send-message="sendMessage"
    @fetch-messages="fetchMessages"
    @open-file="openFile"
    @send-message-reaction="sendMessageReaction"
    @edit-message="editMessage"
    @delete-message="deleteMessage"
    @fetch-more-rooms="fetchMoreRooms"
  >
  </chat-window>

  <b-alert style="margin:10px 0px; padding:5px" show><small>Audio messages are currently not working on iOS. Sorry for the inconvenience.</small></b-alert>


    <div>
    <b-modal 
        id="modal-conv" 
        title="Create private conversation" 
        @show="resetModal"
        @hidden="resetModal"
        hide-footer>
        <b-form-group
            id="input-group-4"
            label="Enter username : "
            label-for="input-4"
            :state="newConvState"
            :invalid-feedback="invalidFeedbackConv"
            >
            <b-row>
                <b-col cols="6">
                    <b-form-input
                    placeholder="Username"
                    v-model="newConvUsername"
                    :state="newConvState"
                    required
                    id="userInput"
                    list="usersList"
                    ></b-form-input>

                    <b-form-datalist id="usersList" :options="usersList"></b-form-datalist>

                </b-col>
                <b-col cols="6">
                    <b-button variant="msstreamblue" @click="createPrivateConv()">Create conversation</b-button>
                </b-col>
            </b-row>
            </b-form-group>
    </b-modal>
    </div>

    <b-modal
    id="modal-new-team"
    ref="modal-new-team"
    title="Create a new team"
    no-close-on-backdrop
    @ok="createTeam"
    @show="resetModal"
    @hidden="resetModal">
      <b-form>
           <b-form-group
            id="input-group-1"
            label="Team name:"
            label-for="team-name"
            :state="teamNameState"
            invalid-feedback="A project name is required"
            >
                <b-form-input
                id="team-name"
                v-model="teamName"
                placeholder="Enter a team name"
                :state="teamNameState"
                required
                ></b-form-input>
            </b-form-group>

            <b-form-group
            id="input-group-2"
            label="Team description (optional):"
            label-for="team-description"
            >
                <b-form-textarea
                id="team-description"
                v-model="teamDescription"
                placeholder="Enter description for the team (optional)"
                required
                ></b-form-textarea>
            </b-form-group>

            <b-form-group
            id="input-group-4"
            label="Add Collaborator: "
            label-for="input-4"
            :state="collabNameState"
            :invalid-feedback="invalidFeedbackCollab"
            >
            <b-row>
                <b-col cols="6">
                    <b-form-input
                    id="input-4"
                    placeholder="Enter collaborator username"
                    v-model="newCollabName"
                    :state="collabNameState"
                    required
                    ></b-form-input>
                </b-col>
                <b-col cols="6">
                    <b-button variant="msstreamblue" @click="addCollab()">Add member to the team</b-button>
                </b-col>
            </b-row>
            </b-form-group>
      </b-form>
      <div>
        <b-table show-empty centered responsive striped bordered :items="collaborators">

          <template v-slot:cell(role)="row">
                        <b-form-select
                            v-model="row.item.role"
                            :options="roles"
                        >
                        </b-form-select>
          </template>
        </b-table>
     </div>
    </b-modal>
</div>


</template>

<script>
  import ChatWindow from 'vue-advanced-chat'
  import 'vue-advanced-chat/dist/vue-advanced-chat.css'
  import { parseTimestamp, isSameDay } from '@/utils/dates'
  import chatService from '@/services/chat.service.js'
  import userService from '@/services/user.service.js'
  import TeamService from "@/services/team.service.js";
  import {WS_CHAT, WS_CHAT_PATH, BASE_URL} from "@/services/base-url.js"
  import { EventBus } from '@/event-bus.js';
  import { io } from "socket.io-client";

  var crService = new chatService();
  var uService = new userService();
  let tService = new TeamService();
  var ws_chat_url = WS_CHAT;
  var ws_chat_path = WS_CHAT_PATH;
  var base_url = BASE_URL;


  export default {
    components: {
      ChatWindow
    },
    data() {
      return {
        roomShow:"all",
        rooms: [],
        allRooms:[],
        currentRoom:null,
        messages: [],
        messagesLoaded: false,
        currentUserId: "",
        loadingRooms: true,
        pageMessage:0,
        messagesPerPage:10,
        roomPage:0,
        roomPerPage:10,
        startMessages: null,
        endMessages: null,
        numberOfMessageLoad:0,
        socketChat:null,
        startRooms:null,
        endRooms:null,
        allUsers:[],
        roomsLoaded:false,
        newConvUsername:"",
        newConvState:null,
        invalidFeedbackConv:"",
        usersList:[],
        suggestionAttribute: 'username',
        roomFilter : "all",

        newCollabName:"",
        collabNameState: null,
        teamName : "",
        teamNameState : null,
        teamDescription : "",
        collaborators : [],
        invalidFeedbackCollab: "Collaborator's username is required",
        roles: ["admin", "editor", "viewer"],
        

      }     
    },
    computed:{
        socket: function() {return this.$socket}
    },
    methods:{

        fetchMessages({room, options = {}}) {
            this.messagesLoaded = false
            this.currentRoom = room
            if (options.reset) {
				this.resetMessages()
				this.roomId = room.roomId
			}

            if(this.currentRoom)
            {
                this.pageMessage++;
                crService.getMessages(this.$auth.token(), this.pageMessage, this.messagesPerPage, room.roomId)
                .then(messages=>{                
                    messages.forEach(message=>{
                        const formattedMessage = this.formatMessage(room.roomId, message)
                        console.log(formattedMessage)
                        this.markMessagesSeen(room, formattedMessage)
                        //On vérifie que le message n'est pas déjà affiché
                        const messageIndex = this.messages.findIndex(m => m._id === message._id)
                        if (messageIndex === -1) {
                            //this.messages = this.messages.concat([formattedMessage])
                            this.messages.unshift(formattedMessage)
                        } else {
                            this.$set(this.messages, messageIndex, formattedMessage)
                        }
                    })
                    EventBus.$emit('updateChatIcon');

                    
                    if(messages.length === 0)
                        this.messagesLoaded = true;
                })
            }''

        },

        async sendMessage({ content, roomId, files, replyMessage })
        {
            const message = {
                sender_id: this.currentUserId,
                content,
                timestamp: new Date()
            }

            
            if(files)
            {
                
                message.files = [
                {
                    name: files[0].name,
                    size: files[0].size,
                    type: files[0].type,
                    extention: files[0].extention || files[0].type,
                    url: files[0].localUrl
                }]

                if(files[0].audio)
                {
                    message.files[0].audio = true
                    message.files[0].duration = files[0].duration
                }
            }
            

                if(replyMessage)
                {
                    message.replyMessage = {
                        _id: replyMessage._id,
                        content: replyMessage.content,
                        sender_id: replyMessage.senderId,
                    }
                    if(replyMessage.files)
                    {
                        message.replyMessage.files= replyMessage.files
                    }
                }                

                //TO-DO ==> On enregistre le message en BDD avec le service
                //On envoie un socket puis
                crService.newMessage(this.$auth.token(),message,roomId)
                .then(newMessage => {
                    
                    this.updateLastMessageRoom(newMessage, roomId)

                    if(!files)
                    {
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, roomId)
                    this.socketChat.emit("newRoomTimeStamp", newMessage.timestamp, roomId)
                    }                    
                    else if (files) {
                        var fileToUpload = files[0]
                        console.log(fileToUpload)
                        this.uploadFile({ file:fileToUpload, messageId: newMessage.uuid, roomId})
                    }

                    
                    const roomIndex = this.allRooms.findIndex(
					r => roomId === r.roomId
                    )
                    this.allRooms[roomIndex].timestamp = message.timestamp

                    //On met à jour l'ordre des chans une fois le dernier message récupéré
                    this.allRooms.sort(function(a,b){
                    return new Date(a.timestamp) - new Date(b.timestamp)
                    })

                    this.allRooms.forEach((room, idx) => {
                        room.index = idx;
                    });

                }).catch(err =>{
                    console.log(err)
                })
        },
        
		async uploadFile({ file, messageId, roomId }) {
            console.log(file)
			let type = file.extension || file.type
			if (type === 'svg' || type === 'pdf') {
				type = file.type
			}

            crService.uploadFile(this.$auth.token(), file, roomId, messageId)
            .then((message)=>{
                this.newMessage(message, roomId)
                this.socketChat.emit("sendMessage", message, this.currentRoom.roomId)
                
                
            })
		},

        newMessage(message, room)
        { 
            const formattedMessage = this.formatMessage(room, message)
            const messageIndex = this.messages.findIndex(m => m._id === message._id)
			if (messageIndex === -1) {
			    this.messages = this.messages.concat([formattedMessage])
			} else {
                this.$set(this.messages, messageIndex, formattedMessage)
			}
			this.markMessagesSeen(room, message)
            EventBus.$emit('updateChatIcon');
        },

        //Danc cette fonction on met à jour le champs "seen du message"
        markMessagesSeen(room, message) {
			if (
				message.sender_id !== this.currentUserId &&
				(!message.seen || !message.seen[this.currentUserId])
			) {
                crService.updateSeenMessage(this.$auth.token(), message._id, this.currentRoom.roomId)
                .then(message=>{
                    this.socketChat.emit("messageSeen", message, this.currentRoom.roomId)
                    this.newMessage(message,  this.currentRoom.roomId)

                    //Si le dernier message du chat correspond au dernier message vue
                    //Alors on le met à jour depuis la BDD
                    if(this.currentRoom.lastMessage._id === message._id)
                    {
                        this.getLastMessage(this.currentRoom)
                    }
                })
			}
		},

		formatMessage(room, message) {

            const { sender_id, timestamp } = message
			var formatMessage = {
				...message,
				...{
					senderId: sender_id,
					_id: message._id,
					seconds: timestamp.seconds,
					timestamp: parseTimestamp(timestamp, 'HH:mm'),
					date: parseTimestamp(timestamp, 'DD MMMM YYYY'),
					username: sender_id,
					// avatar: senderUser ? senderUser.avatar : null,
					distributed: true,
				}
			}
            console.log(base_url)
            if(formatMessage.files)
            {
                formatMessage.files[0].url = base_url+ formatMessage.files[0].path
            }

            return formatMessage;
		},

        formatTimestamp(date, timestamp) {
			const timestampFormat = isSameDay(date, new Date()) ? 'HH:mm' : 'DD/MM/YY'
			const result = parseTimestamp(timestamp, timestampFormat)
			return timestampFormat === 'HH:mm' ? `Today, ${result}` : result
		},
       
        resetMessages() {
			this.messages = []
			this.messagesLoaded = false
			this.startMessages = null
			this.endMessages = null
            this.pageMessage=0
		},

        resetRooms() {
			this.loadingRooms = true
			this.loadingLastMessageByRoom = 0
			this.roomsLoadedCount = 0
			this.rooms = []
			this.allRooms = []
			this.roomsLoaded = false
			this.startRooms = null
			this.endRooms = null
            this.roomPage = 0
			this.resetMessages()
		},

        openFile({ message }) {
			window.open(message.files[0].url, '_blank')
		},

        updateLastMessageRoom(message, roomId)
        {
            const roomIndex = this.allRooms.findIndex(
			    r => roomId === r.roomId
            )
            const lastMessage = this.formatLastMessage(message)
            this.allRooms[roomIndex].lastMessage = lastMessage;
            this.allRooms[roomIndex].lastUpdated = lastMessage.timestamp
        },

        connectToChatServer()
        {
            if(!this.socketChat)
            {
                this.socketChat = io(ws_chat_url, { path: ws_chat_path });
                //this.socketChat = io("ws://localhost:8082");

                this.socketChat.on("connect", () => {
                    this.socketChat.emit("room", this.$auth.getMyUser().username)
                })

                this.socketChat.on("newMessage", (message, roomId)=>{
                    if(this.currentRoom.roomId === roomId)
                        this.newMessage(message, roomId);
                    this.updateLastMessageRoom(message, roomId)           
                })                

                this.socketChat.on('joined', (roomId) => {
                    console.log("Succesfully joined chat : " + roomId)
                })

                this.socketChat.on('messageSeen', (message, roomId)=>{
                    if(roomId === this.currentRoom.roomId)
                    {
                        const idxMessage = this.messages.findIndex(mes => mes._id === message._id)
                        if(idxMessage != -1)
                        {
                            this.newMessage(message, roomId)
                        }
                    }
                })

                this.socketChat.on('newRoomTimeStamp', (newTS, roomId)=>
                {
                    const roomIndex = this.allRooms.findIndex(
					r => roomId === r.roomId
                    )
                    this.allRooms[roomIndex].timestamp = newTS

                    //On met à jour l'ordre des chans une fois le dernier message récupéré
                    this.allRooms.sort(function(a,b){
                    return new Date(a.timestamp) - new Date(b.timestamp)
                    })

                    this.allRooms.forEach((room, idx) => {
                        room.index = idx;
                    });

                })
                
            }
        },

        async sendMessageReaction({ reaction, remove, messageId, roomId }) {
            if(!remove)
            {
                crService.addReaction(this.$auth.token(), messageId, reaction.unicode, roomId)
                .then(newMessage=>{
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, roomId)
                })
            }else if (remove)
            {
                crService.removeReaction(this.$auth.token(), messageId, reaction.unicode, roomId)
                .then(newMessage=>{
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, roomId)
                })
            }
        },

        async editMessage({ messageId, newContent, roomId, files }) {
			const newMessage = { edited: new Date() }
			newMessage.content = newContent
			if (files) {
				newMessage.files = [{
					name: files[0].name,
					size: files[0].size,
					type: files[0].type,
					extension: files[0].extension || files[0].type,
					url: files[0].url || files[0].localUrl
				}]
				if (files[0].audio) {
					newMessage.files[0].audio = true
					newMessage.files[0].duration = files[0].duration
				}
			} else {
				newMessage.$unset = {files:true}
			}
                crService.editMessage(this.$auth.token(),newMessage,roomId, messageId)
                .then(newMessage => {
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, this.currentRoom.roomId)
                    if (files) {
                        var fileToUpload = files[0]
                        this.uploadFile({ file:fileToUpload, messageId: newMessage.uuid, roomId})
                    }
                }).catch(err =>{
                    console.log(err)
                })
		},

        async deleteMessage({ message, roomId }) {
            crService.deleteMessage(this.$auth.token(), message._id, roomId)
            .then(deletedMessage=>{
                this.newMessage(deletedMessage, roomId)
                this.socketChat.emit("sendMessage", deletedMessage, this.currentRoom.roomId)

            })
		},

        fetchRooms() {
			this.resetRooms()
			this.fetchMoreRooms()
		},

        async fetchMoreRooms() {

			if (this.endRooms && !this.startRooms) return (this.roomsLoaded = true)
			
            this.roomPage++;
            crService.getRooms(this.$auth.token(), this.roomPage, this.roomPerPage)
            .then(chatRooms=>
            {
                if(chatRooms.length === 0 || chatRooms.length < this.roomPerPage)
                {
                    this.roomsLoaded = true;
                }
                
                if (this.startRooms) this.endRooms = this.startRooms                
			    this.startRooms = chatRooms[chatRooms.length - 1]

                const roomUserIds = []
                chatRooms.forEach(room => {
                    room.users.forEach(userId => {
                        const foundUser = this.allUsers.find(user => user === userId)
                        if (!foundUser && roomUserIds.indexOf(userId) === -1) {
                            roomUserIds.push(userId)
                        }
                    }) 
                })

                this.allUsers = [...this.allUsers, ...roomUserIds]

            
                const formattedRooms = []
                chatRooms.forEach((room, indexRoom) => {
                    const lastMessage = {}

                    if(!room.lastMessage)
                    {
                        lastMessage['content'] = 'Room created'
                        lastMessage['timestamp'] = this.formatTimestamp(
                                new Date(room.lastUpdated),
                                room.lastUpdated
                        )
                    }else
                    {
                        lastMessage = room.lastMessage;
                    }
                    
                    const usersLists = []
                    room.users.forEach(user=>{
                        let newUser = {
                        _id:user,
                        username:user,
                        avatar:"",
                        }
                        usersLists.push(newUser);
                    })

                    let roomName = room.roomName;
                    if(room.type === "custom")
                    {
                        room.users.forEach(user =>{
                            if(user != this.$auth.getMyUser().username)
                                roomName = user
                        })
                    }

                    formattedRooms.push({
                        roomId: room.uuid,
                        roomName: roomName,
                        index:indexRoom,
                        lastMessage:lastMessage,
                        lastUpdated:room.lastUpdated,
                        users:usersLists,
                        timestamp:room.lastUpdated,
                        type:room.type,
                    })

                    this.socketChat.emit("room", room.uuid)
                })

                this.allRooms = this.allRooms.concat(formattedRooms)                

                this.allRooms.forEach(room=>
                {
                    this.getLastMessage(room)
                })

                this.loadingRooms = false
                this.roomsLoadedCount = this.allRooms.length
                
                //Avec cette fonction on n'affiche que les rooms dont le type est sélectionnée
                this.selectRooms(this.roomFilter)

                if (!this.allRooms.length) {
                    this.loadingRooms = false
                    this.roomsLoadedCount = 0
			    }
            })
		},

        selectRooms(type)
        {
            this.roomFilter = type;
            if(type === "all")
            {
                this.rooms = this.allRooms;
            } else
            {
                this.rooms = [];
                let tmpRoom = [];
                this.allRooms.forEach(room=>
                {
                    if(room.type === type)
                        tmpRoom.push(room)
                })
                this.rooms = tmpRoom;
            }
        },

        getLastMessage(room)
        {
            crService.getLastMessage(this.$auth.token(), room.roomId)
            .then(messages=>{
                messages.forEach(message=>{
                    const lastMessage = this.formatLastMessage(message)

					const roomIndex = this.rooms.findIndex(
					r => room.roomId === r.roomId
                    )
					this.rooms[roomIndex].lastMessage = lastMessage
                    this.rooms[roomIndex].timestamp = message.timestamp
					this.rooms = [...this.rooms]                    
                })

                //On met à jour l'ordre des chans une fois le dernier message récupéré
                this.rooms.sort(function(a,b){
                return new Date(a.timestamp) - new Date(b.timestamp)
                })

                this.rooms.forEach((room, idx) => {
                    room.index = idx;
                });
            })
        },

        formatLastMessage(message)
        {
            if (!message.timestamp) return

            let content = message.content

			if (message.files)
				content = `${message.files[0].name}.${message.files[0].extension ||
					message.files[0].type}`
            
            return {
				...message,
				...{
					content,
					timestamp: this.formatTimestamp(
						new Date(message.timestamp),
						message.timestamp
					),
					distributed: true,
					seen: message.sender_id === this.currentUserId ? message.seen : null,
					new:
						message.sender_id !== this.currentUserId &&
						(!message.seen || !message.seen[this.currentUserId])
				}
			}            
        },
        
        createPrivateConversationModal()
        {
            this.usersList = []
            uService.getUsers(this.$auth.token())
            .then(users=>{
                users.forEach(user=>{
                    this.usersList.push(user.username)
                })
                this.$bvModal.show("modal-conv")                
            })
        },

        createPrivateConv()
        {
            //1) On fait une requête pour vérifier que la room n'existe pas
            //2) Si elle n'existe pas on créer la room en BDD et on recharge la page pour l'afficher

            crService.checkPrivateConv(this.$auth.token(),this.newConvUsername )
            .then(res=>{
                if(res.length === 0)
                {
                    //On fait la room privé
                    crService.createPrivateConv(this.$auth.token(), this.$auth.getMyUser().username, this.newConvUsername)
                    .then(cr=>{
                        this.fetchRooms()
                        this.$bvModal.hide('modal-conv')
                    })
                }else
                {
                    this.newConvState = false;
                    this.invalidFeedbackConv = "You already have a private conversation with this user"
                }
            }).catch(error => {
                if(error.response.status === 404)
                {
                    this.newConvState = false;
                    this.invalidFeedbackConv = error.response.data
                }
            })
        },

        resetModal()
        {
            this.newConvState=null;
            this.newConvUsername="";
            this.invalidFeedbackConv="";
            this.newCollabName = "";
            this.collabNameState = null;
            this.teamName = "";
            this.teamNameState = null;
            this.teamDescription = "";
            this.collaborators = [];
            this.invalidFeedbackCollab= "Collaborator's username is required"

        },
        
        createTeam(bvModalEvt)
        {
                bvModalEvt.preventDefault()
            if(!this.teamName)
            {
                this.teamNameState = false;
                return;
            }

            let body = JSON.stringify({
                name: this.teamName,
                description: this.teamDescription,
                group: this.collaborators
            });

            tService.createTeam(this.$auth.token(),body)
            .then(response=>{
                this.$nextTick(() => {
                this.$bvModal.hide('modal-new-team')
                this.fetchRooms();
                })
            }).catch(err=>{
                console.error(err)
            })
        },

        addCollab()
        {
            if(!this.newCollabName)
            {
            this.invalidFeedbackCollab = "Collaborator's username is required"
            this.collabNameState = false;
            return;
            }
            
            uService.getUser(this.$auth.token(), this.newCollabName)
            .then(response =>{
            this.collabNameState = true;
            let newCollab = 
            {
                username:this.newCollabName,
                role:'viewer'
            }
            this.collaborators.push(newCollab);
            }).catch(err=>{
            if(err.response.status === 404)
            {
                this.invalidFeedbackCollab = "User " + this.newCollabName + " not found";
                this.collabNameState = false;
            }
            })
        },  
        OpenChatSupport() {
            var url = "#/chat/singleConv/quanteec";
            window.open(url, this.userSelected, "width=1200, height=750");
        },
    },
    mounted()
    {
        this.currentUserId = this.$auth.getMyUser().username;
        this.connectToChatServer();
        this.fetchRooms()
        //this.loadRoom();

        //this.updateuserOnlineStatus();
    },
    destroyed() {
        this.socketChat.disconnect();
    },
  }
</script>